import { useEffect, useRef } from 'react';
import './ckeditor-theme.css';

// Loader singleton — script CDN cuma dimuat sekali walau CKEditorField dipakai berkali-kali
let ckLoadPromise = null;
function loadCKEditor() {
  if (window.ClassicEditor) return Promise.resolve(window.ClassicEditor);
  if (ckLoadPromise) return ckLoadPromise;
  ckLoadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-ckeditor5]');
    if (existing) {
      existing.addEventListener('load', () => resolve(window.ClassicEditor));
      existing.addEventListener('error', () => reject(new Error('Gagal memuat CKEditor')));
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://cdn.ckeditor.com/ckeditor5/39.0.0/classic/ckeditor.js';
    script.setAttribute('data-ckeditor5', '1');
    script.onload = () => resolve(window.ClassicEditor);
    script.onerror = () => reject(new Error('Gagal memuat CKEditor'));
    document.head.appendChild(script);
  });
  return ckLoadPromise;
}

/**
 * Rich text editor untuk field "Konten Artikel".
 * `initialValue` hanya dipakai saat instance dibuat (uncontrolled-ish, seperti versi PHP);
 * gunakan prop `key` di parent untuk memaksa remount kalau initialValue berganti dari luar
 * (mis. saat pindah dari mode "loading" ke data hasil fetch pada halaman Edit).
 */
export default function CKEditorField({ initialValue = '', onChange, placeholder = '' }) {
  const textareaRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    let editorInstance = null;

    loadCKEditor()
      .then((ClassicEditor) => {
        if (cancelled || !textareaRef.current) return;
        return ClassicEditor.create(textareaRef.current, {
          toolbar: {
            items: [
              'heading',
              '|',
              'bold',
              'italic',
              'underline',
              'strikethrough',
              '|',
              'bulletedList',
              'numberedList',
              '|',
              'alignment',
              'blockQuote',
              'link',
              'insertTable',
              '|',
              'undo',
              'redo',
            ],
          },
          language: 'id',
        }).then((editor) => {
          if (cancelled) {
            editor.destroy();
            return;
          }
          editorInstance = editor;
          editor.setData(initialValue || '');
          editor.model.document.on('change:data', () => {
            onChange?.(editor.getData());
          });
        });
      })
      .catch((err) => console.error('Error saat memuat CKEditor:', err));

    return () => {
      cancelled = true;
      if (editorInstance) editorInstance.destroy().catch(() => {});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="text-neutral-900">
      <textarea ref={textareaRef} defaultValue={initialValue} placeholder={placeholder} />
    </div>
  );
}
